import _ from "lodash-es";
import { fixDateFromDataBase } from "../../tools/formatDate";

const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};

const ChartsPerformanceDataCompute = (props, edges, keyTab) => {
  // console.log("5 - ===> Compute", props, keyTab);
  const { intl } = props;

  if (edges) {

    if (keyTab === "clientPerf") {   // remove vendeur data...

      const mapData = new Map();
      edges.map(o => {
        const key = "Cli" + (o.client ? o.client.id : "null")
          + "_Cat" + (o.category ? o.category.id : "null")
          + "_Pro" + (o.project ? o.project.id : "null");

        const dataFound = mapData.get(key);

        if (dataFound === null || dataFound === undefined) {
          
          const element = {
            ...o            
          }          
          mapData.set(key, element);

        } else {

          const element = {
            ...o,
            p1Amount: FIXED0(dataFound.p1Amount + o.p1Amount),
            p2Amount: FIXED0(dataFound.p2Amount + o.p2Amount)
          } 
          mapData.set(key, element);
        }
      });
      const tabData = Array.from(mapData.values());
      return {
        tabData
      }
    }    

    return {
      //periodCategory: mapPeriodeCategory,
      //   previousYearData: sourcePreviousYearData,
      //   currentYearData: sourceCurrentYearData,
      //   previousYearDataNegative: sourcePreviousYearDataNegative,
      //   currentYearDataNegative: sourceCurrentYearDataNegative,
      tabData: edges.map(o => {
        o.key = o.id;
        return o;
      })
    };
  }
};

export default ChartsPerformanceDataCompute;
